export const SITE_NAME = '善良的女秘书';
export const SITE_TAGLINE = '影视剧剧情介绍与最新资讯';
export const SITE_DESCRIPTION =
  '善良的女秘书网站提供详尽的影视剧剧情介绍、角色分析及相关新闻更新，涵盖电视剧和电影等多种影视内容，帮助用户了解剧情发展与角色背景。';
export const SITE_EMAIL = 'contact@kindsecretary.com';

export const navLinks = [
  { label: '首页', path: '/' },
  { label: '电视剧', path: '/category/tv' },
  { label: '电影', path: '/category/movie' },
  { label: '资讯', path: '/news' },
  { label: '关于', path: '/about' },
];

export const categoryMeta = {
  tv: {
    key: 'tv',
    name: '电视剧',
    desc: '汇集热门与经典电视剧作品，涵盖都市、悬疑、古装、家庭等多元题材，提供剧情介绍、演员阵容与更新动态。',
  },
  movie: {
    key: 'movie',
    name: '电影',
    desc: '精选国内外优秀电影作品，从文艺剧情到商业类型，提供剧情简介、主创信息与观影参考。',
  },
};

export const footerLinks = {
  browse: [
    { label: '电视剧', path: '/category/tv' },
    { label: '电影', path: '/category/movie' },
    { label: '最新资讯', path: '/news' },
  ],
  about: [
    { label: '关于我们', path: '/about' },
    { label: '联系方式', path: '/about' },
    { label: '免责声明', path: '/about' },
  ],
};